import AuthLayoutComponent from '../../features/ui/auth-layout/auth-layout';
import { CompleteRegisterForm } from '@old/features/public/complete-register/complete-register-form';

export function CompleteRegister() {
  return (
    <AuthLayoutComponent>
      <CompleteRegisterForm />
    </AuthLayoutComponent>
  );
}
